import { render } from "./SocialIcon.vue?vue&type=template&id=2b3774ae&scoped=true"
import script from "./SocialIcon.vue?vue&type=script&lang=js"
export * from "./SocialIcon.vue?vue&type=script&lang=js"

import "./SocialIcon.vue?vue&type=style&index=0&id=2b3774ae&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3774ae"],['__file',"src/scripts/sections/common/SocialIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b3774ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b3774ae', __exports__)) {
    api.reload('2b3774ae', __exports__)
  }
  
  module.hot.accept("./SocialIcon.vue?vue&type=template&id=2b3774ae&scoped=true", () => {
    api.rerender('2b3774ae', render)
  })

}


export default __exports__